import React from "react";
import PropTypes from "prop-types";

import { Form, Input } from "antd";

/**
 * Form input text with a label on top of it.
 * Any unrecognized prop will be propagated to the input component.
 */
const FormInputWithLabel = ({ className, input, label, placeholder, meta: { touched, error, visited }, ...custom }) => (
    <div className={className}>
        <Form.Item
            colon={false}
            hasFeedback={true}
            help={touched && error}
            label={label}
            validateStatus={touched && error ? "error" : ""}
        >
            <Input placeholder={placeholder} {...input} {...custom} />
        </Form.Item>
    </div>
);

FormInputWithLabel.propTypes = {
    /**
     * Class for the root element
     */
    className: PropTypes.string,
    /**
     * Props to be passed down to the actual input field.
     * Allows for easy integration with redux-form
     */
    input: PropTypes.object.isRequired,
    /**
     * Label for the field
     */
    label: PropTypes.string,
    /**
     * Placeholder for the input field
     */
    placeholder: PropTypes.any,
    /**
     * Meta information about the field.
     * Allows for easy integration with redux-form
     */
    meta: PropTypes.shape({
        error: PropTypes.string, // Error message, displayed only if touched==true
        touched: PropTypes.bool // Whether the field has been interacted with
    }).isRequired
};

export default FormInputWithLabel;
